import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PROJECT_TEMPLATES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PROJECT_TEMPLATES');
export const PROJECT_TEMPLATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PROJECT_TEMPLATES_CRUD_ACTION_CONSTANTS
);
